<span>
    <app-svg-icon [icon]="'full-screen'" (click)="toggleScreen()"></app-svg-icon>
</span>